import clsx from 'clsx';
import { useState } from 'react';

import {
  AssignmentContent,
  CardstackAssignment,
} from 'shared/api/assignment-service';
import { useAppDispatch } from 'shared/lib/redux';
import { setEditingAssignment } from 'features/assignment-panel';

import styles from './styles.module.scss';

type ActivityItemProps = {
  activity: AssignmentContent;
  editingAssignment: CardstackAssignment;
};

export const ActivityItem = ({
  editingAssignment,
  activity,
}: ActivityItemProps) => {
  const dispatch = useAppDispatch();

  const [isActivityActive, setIsActivityActive] = useState(true);

  const handleDeleteActivityClick = () => {
    const updatedContent = editingAssignment.content.map(
      (activityObj): AssignmentContent => {
        return activityObj.cardstackKey === activity.cardstackKey
          ? {
              ...activityObj,
              isActivityActive: !isActivityActive,
            }
          : activityObj;
      },
    );

    dispatch(
      setEditingAssignment({
        ...editingAssignment,
        content: updatedContent,
      }),
    );

    setIsActivityActive(!isActivityActive);
  };

  return (
    <div
      className={clsx(
        'd-flex',
        'justify-content-between',
        'align-items-center',
        styles.activityItem,
        {
          [styles.inactive]: !isActivityActive,
        },
      )}
    >
      <div className={styles.activityTitle}>{activity.cardstackTitle}</div>
      <button
        onClick={handleDeleteActivityClick}
        className={clsx(styles.actionButton, 'btn', 'btn-icon-ghost')}
        aria-label="Delete"
        data-testid="delete-activity-btn"
      >
        {isActivityActive ? (
          <i
            className="icon-v2-close rhythm-icon light-color-icon"
            aria-hidden
          />
        ) : (
          <i
            className="icon-v2-reset rhythm-icon light-color-icon"
            aria-hidden
          />
        )}
      </button>
    </div>
  );
};
